module.exports = __webpack_public_path__ + "static/media/mimi9.b5ec7c32.gif";